import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const deleteFacilityGroupMutationAtom = createMutationAtomFactory(
  'settings.facilityGroupDelete',
  ({ id }: { id: string }) => ({
    coreFacilityGroupDelete: {
      __args: {
        id,
      },
    },
  }),
);
